'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mustache = require('mustache');

var _mustache2 = _interopRequireDefault(_mustache);

var _util = require('../util');

var _shared = require('./shared');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      '& a': {
        color: 'inherit'
      },
      '& ul, & ol, & p, & h1, & h2, & h3, & h4, & h5': {
        marginBottom: 20
      },
      '& button': {
        fontWeight: 'bold',
        fontSize: 20,
        fontFamily: theme.fontSecondary,
        lineHeight: 1,
        background: theme.bgCardTitle,
        color: theme.colorCardTitle,
        textTransform: 'uppercase',
        display: 'inline-block',
        borderRadius: 4,
        padding: [[11, 18, 13]],
        whiteSpace: 'normal',
        border: 'none'
      },
      '& input[type="text"]': {
        font: 'inherit',
        border: [[1, 'solid']],
        padding: [[4, 8]]
      }
    }
  };
};

var Html = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(Html, _React$Component);

  function Html() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Html);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Html.__proto__ || Object.getPrototypeOf(Html)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      html: null
    }, _this.componentWillMount = function () {
      _this.setState({
        html: _this.getHtml(_this.props)
      });
    }, _this.componentWillReceiveProps = function (props) {
      return _this.setState({
        html: _this.getHtml(props)
      });
    }, _this.getHtml = function (_ref2) {
      var config = _ref2.config,
          content = _ref2.content,
          theme = _ref2.theme;
      return config.htmlTemplate ? _mustache2["default"].render(config.htmlTemplate, _extends({}, content, {
        theme: theme
      })) : content.html || '';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Html, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          nowrap = _props.nowrap,
          classes = _props.classes,
          children = _props.children;
      var html = {
        __html: this.state.html
      };
      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_shared.Content, {
        classes: {
          _root: classes.root
        },
        dangerouslySetInnerHTML: html,
        nowrap: nowrap
      }), children);
    }
  }]);

  return Html;
}(_react2["default"].Component), _class2.id = 'html', _temp2)) || _class);
exports["default"] = Html;